import Vue from "vue";

Vue.directive("rolePermission", {
  bind: (el, binding, vnode) => {
    const requiredPermission = binding.value;
    const statePermission = vnode.context.$store.getters["auth/role"];
    if (statePermission !== requiredPermission) {
      el.style.display = "none";
    }
  }
});

//调用 v-yu_permission

Vue.directive("menuPermission", {
  bind: (el, binding, vnode) => {
    const requiredPermission = binding.value;
    const statePermission = vnode.context.$store.getters["auth/permissions"];
    console.log("----", vnode.context.$store.getters["auth/permissions"]);
    if (statePermission !== requiredPermission) {
      el.style.display = "none";
    }
  }
});



// WEBPACK FOOTER //
// ./src/utils/directives/permission.js